export enum IncomeType {
    Monthly = 'Monthly',
    Annual = 'Annual'
}

export class Income {
    public readonly amount: number;
    public readonly type: IncomeType;

    constructor(amount?: number, type?: IncomeType)
    constructor(amount: number, type: IncomeType) {
        this.amount = amount;
        this.type = type;
    }

    public static from(json): Income {
        const income = new Income();
        Object.assign(income, json);
        return income;
    }

    public getAmount() {
        return this.amount;
    }

    public isMonthly(): boolean {
        return this.type === IncomeType.Monthly;
    }
}
